import { DraftState } from '../slice';

const toggleSidebarReducer = (state: DraftState) => {
  state.sidebarOpen = !state.sidebarOpen;
};

export default toggleSidebarReducer;
